import {useContext} from "react";
import axios from "axios";
import {API_URL} from "../config";
import {getHeaderOptions} from "../lib/request-helper";
import {ShowLoaderContext} from "./show-loader-context";
import {FormInputDriverStatus} from "../types/forms";
import {DriverStatus} from '../types/driver-status';
import {SortableUpdate} from '../types/sortable';

export default function useDriverStatus() {
  const {setShowLoader} = useContext(ShowLoaderContext);

  const listing = async (
    page: number,
    perPage: number,
    search: string = "",
    sortField: string | null = null,
    sortDirection: string | null = null
  ): Promise<any> => {
    setShowLoader(true);
    try {
      const result = await axios.get(
        `${API_URL}/driver-status?page=${page}&perPage=${perPage}&search=${search}&sortProp=${sortField}&sortDir=${sortDirection}`,
        getHeaderOptions()
      );
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  const listingSimpleDriverStatus = async (): Promise<any> => {
    setShowLoader(true);
    try {
      const result = await axios.get(`${API_URL}/driver-status/simple`, getHeaderOptions());
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  const getById = async (id: string): Promise<DriverStatus> => {
    setShowLoader(true);
    try {
      const result = await axios.get(`${API_URL}/driver-status/${id}`, getHeaderOptions());
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  const createDriverStatus = async (inputData: FormInputDriverStatus): Promise<DriverStatus> => {
    setShowLoader(true);
    try {
      const result = await axios.post(`${API_URL}/driver-status`, inputData, getHeaderOptions());
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  const updateDriverStatus = async (id: string, inputData: FormInputDriverStatus): Promise<DriverStatus> => {
    setShowLoader(true);
    try {
      const result = await axios.put(`${API_URL}/driver-status/${id}`, inputData, getHeaderOptions());
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  const updateDriverStatusPosition = async (items: Array<SortableUpdate>): Promise<DriverStatus> => {
    setShowLoader(true);
    try {
      const result = await axios.put(`${API_URL}/driver-status/position`, {items}, getHeaderOptions());
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  const forceDeleteDriverStatus = async (id: string): Promise<DriverStatus> => {
    setShowLoader(true);
    try {
      const result = await axios.delete(`${API_URL}/driver-status/${id}`, getHeaderOptions());
      setShowLoader(false);
      return result.data;
    } catch (e: any) {
      console.log(e);
      setShowLoader(false);
      throw e;
    }
  };

  return {
    listing,
    listingSimpleDriverStatus,
    getById,
    createDriverStatus,
    updateDriverStatus,
    updateDriverStatusPosition,
    forceDeleteDriverStatus,
  };
}
